export const SITE_NAME = "+Bake Cafe"
export const SITE_DESCRIPTION =
  "Artisanal Asian-Fusion Bakery & Cafe in Rancho Cucamonga"
export const PLUSBAKE_LOGO_URL = "/images/plusbake/logo.svg"
export const PLUSBAKE_FAVICON_URL = "/images/plusbake/favicon-512.png"

// Build-time FALLBACK for the catering toggle. The live value is owned by
// Medusa and edited in Admin → Settings → Store; see lib/data/site-settings.ts.
// This is what the storefront uses when the backend cannot be reached, so keep
// it `false`: an outage should leave a hidden surface hidden.
// Typed `boolean` (not literal `false`) so gated branches stay type-checked.
export const CATERING_ENABLED: boolean = false

// Feature flag — hides the pre-order shop and every entry point to it (navbar,
// footer, homepage + visit CTAs, search, sitemap.xml, llms.txt) and 404s the
// /store, /products/* and /categories/* routes, without deleting any code.
// /cart, /checkout and /account order history stay reachable on purpose so a
// guest mid-order can still finish. Flip back to `true` to fully restore.
// Typed `boolean` (not literal `false`) so gated branches stay type-checked.
// Re-enabling also means deleting the /store and /store/ redirects to /menu in
// vercel.json. They are 308s, so browsers that already followed one keep going
// to /menu until their cache clears.
export const PREORDER_ENABLED: boolean = false

export const TOAST_ORDER_URL =
  "https://order.toasttab.com/online/plus-bake-cafe-rancho-8685-base-line-road"

// Canonical outbound URL forms. These were each written three different ways
// across the site (instagram.com vs www vs trailing slash; maps.google.com/?q=
// vs the documented api=1 form), which splits link equity and makes a bad link
// a twelve-file fix instead of a one-line one.
export const INSTAGRAM_URL = "https://www.instagram.com/tusplusbake"
export const TIKTOK_URL = "https://www.tiktok.com/@tusplusbake"

export const GOOGLE_MAPS_DIRECTIONS_URL =
  "https://www.google.com/maps/search/?api=1&query=8685%20Base%20Line%20Rd%20Suite%20B%20Rancho%20Cucamonga%20CA%2091730"

// Google Business Profile listing (CID). Use for schema hasMap/sameAs; keep
// GOOGLE_MAPS_DIRECTIONS_URL for "Get directions" buttons.
export const GOOGLE_BUSINESS_PROFILE_URL =
  "https://maps.google.com/?cid=9908642099109370456"

export const BAKERY_PHONE = "(909) 256-4016"
export const BAKERY_PHONE_TEL = "+19092564016"
export const BAKERY_EMAIL = "talktome@takeurseat.com"
export const CATERING_EMAIL = "catering@takeurseat.com"
export const PREORDER_EMAIL = "orders@plusbake.com"

export const BAKERY_ADDRESS = {
  street: "8685 Base Line Rd, Suite B",
  city: "Rancho Cucamonga",
  region: "CA",
  postalCode: "91730",
  country: "US",
}

export const BAKERY_HOURS = {
  opens: "07:30",
  // Café closing time — this is when the business actually closes and drives all
  // structured data (openingHoursSpecification). Do NOT lower this to the kitchen
  // cutoff: bakery items and drinks are still sold until 3:30 PM.
  closes: "15:30",
  // Hot-kitchen (made-to-order food) cutoff. Informational only — intentionally
  // NOT emitted in schema.org hours so search engines never think the business
  // closes at 2 PM.
  kitchenCloses: "14:00",
  label: "Daily 7:30 AM – 3:30 PM",
  // Canonical guest-facing wording for the kitchen-vs-café distinction. Reused
  // everywhere the notice appears so the copy stays identical site-wide.
  kitchenNotice: "Kitchen orders until 2 PM • Bakery + drinks until 3:30 PM",
  kitchenNoticeLong:
    "Kitchen orders are accepted until 2:00 PM. Bakery items and drinks are available until 3:30 PM.",
}

export const BAKERY_GEO = {
  latitude: 34.12144,
  longitude: -117.61655,
}

export const TUS_CATERING_URL = "https://takeurseat.com/catering"
